import { generateHeadTitle } from 'shared/components/common'
import Layout from 'shared/layout'
import Gallery from 'src/modules/gallery'

const GalleryScreen = () => {
  return (
    <>
      {generateHeadTitle('Gallery | VTR Minting Platform')}
      <Layout>
        <Gallery />
      </Layout>
    </>
  )
}

export default GalleryScreen
